import axios from "axios";
console.log(process.env.REACT_APP_API_URL)
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api/v1",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Mon profil
export const empGetMe       = ()     => api.get("/api/v1/employee/me/");
export const empGetStats    = ()     => api.get("/api/v1/employee/stats/");
export const empGetActivity = ()     => api.get("/api/v1/employee/activity/");

// Tickets
export const empGetTickets        = (p={})    => api.get("/api/v1/support/tickets/",              { params: p });
export const empGetTicket         = (id)      => api.get(`/api/v1/support/tickets/${id}/`);
export const empUpdateTicket      = (id, d)   => api.patch(`/api/v1/support/tickets/${id}/`,      d);
export const empPostMessage       = (id, d)   => api.post(`/api/v1/employee/tickets/${id}/messages/`, d);
export const empSelfAssign        = (id)      => api.post(`/api/v1/employee/tickets/${id}/assign/`);

// Modération
export const empGetComments       = (p={})    => api.get("/api/v1/employee/moderation/comments/",  { params: p });
export const empDeleteComment     = (id)      => api.delete(`/api/v1/employee/moderation/comments/${id}/`);

// Finance
export const empGetWithdrawals    = (p={})    => api.get("/api/v1/employee/withdrawals/",           { params: p });
export const empApproveWithdrawal = (id)      => api.post(`/api/v1/employee/withdrawals/${id}/approve/`);
export const empRejectWithdrawal  = (id, d)   => api.post(`/api/v1/employee/withdrawals/${id}/reject/`, d);

// Payouts (Mobile Money / Banque / PayPal) — action : approve | complete | reject
export const empGetPayouts        = (p={})    => api.get("/api/v1/employee/payouts/",               { params: p });
export const empPayoutAction      = (id, action, d={}) => api.post(`/api/v1/employee/payouts/${id}/${action}/`, d);

// Utilisateurs
export const empGetUsers          = (p={})    => api.get("/api/v1/employee/users/",                { params: p });

export default api;